<div class="header">
  <h2>Dettaglio <strong>Ordinativo</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a style="cursor: pointer;" [routerLink]="['/inspection-general']">Gestione Ispezioni</a></li>
      <li><a style="cursor: pointer;" [routerLink]="['/inspection/' + inspectionOrder.inspection.id_inspection]">Dettaglio Ispezione</a></li>
      <li class="active">Dettaglio Ordinativo</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i>Informazioni <strong>Ordinativo</strong></h3>
      </div>
      <div class="panel-content">
        <h4><i class="fa fa-info-circle"></i> <strong>Numero:</strong> {{ inspectionOrder?.number }}</h4>
        <h4><i class="fa fa-exclamation-triangle"></i> <strong>Ispezione:</strong> {{ inspectionOrder?.inspection?.pa?.name }}</h4>
        <h4><i class="fa fa-user"></i> <strong>Nome Referente:</strong> {{ inspectionOrder?.referent_name }}</h4>
        <h4><i class="fa fa-phone "></i> <strong>Telefono Referente:</strong> {{ inspectionOrder?.referent_phone }}</h4>
        <h4><i class="fa fa-envelope "></i> <strong>E-mail Referente:</strong> {{ inspectionOrder?.referent_email }}</h4>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer">
        <a class="btn btn-blue" [routerLink]="['/inspection/order/update/' + inspectionOrder.id_inspection_order]"><i class="icon-pencil"></i> Modifica</a>
        <a class="btn btn-danger" (click)="openDeleteInspectionOrderModal()"><i class="icon-trash"></i> Elimina</a>
      </div>
    </div>
  </div>
  <div class="col-md-8">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-list"></i><strong>Richieste di Consegna</strong></h3>
      </div>
      <div class="panel-content">
        <table *ngIf="inspectionDeliveryRequests.length > 0" class="table table-hover">
          <thead>
          <tr>
            <th style="width: 15%;">Ordinativo</th>
            <th style="width: 20%;">Protocollo Ente</th>
            <th style="width: 50%;">RDC</th>
            <th *ngIf="user.fk_id_role <= 1" style="width: 15%;">Azioni</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let inspectionDeliveryRequest of inspectionDeliveryRequests |
                  paginate: paginationConfig">
            <td>{{ inspectionOrder?.number }}</td>
            <td>{{ inspectionDeliveryRequest.institution_protocol }}</td>
            <td>{{ inspectionDeliveryRequest.code }}</td>
            <td *ngIf="user.fk_id_role <= 1">
              <a class="edit btn btn-sm btn-default"
                 [routerLink]="['/inspection/rdc/update/' + inspectionDeliveryRequest.id_inspection_delivery_request]"
                 mat-raised-button
                 matTooltip="Modifica"
                 matTooltipPosition="above">
                <i class="icon-note"></i></a>
              <a class="delete btn btn-sm btn-danger"
                 (click)="openDeleteInspectionDeliveryRequestModal(inspectionDeliveryRequest)"
                 mat-raised-button
                 matTooltip="Elimina"
                 matTooltipPosition="above">
                <i class="icons-office-57"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="inspectionDeliveryRequests.length > 0">
          <pagination-controls (pageChange)="pageChanged($event)"
                               [autoHide]="paginationParams.autoHide"
                               [maxSize]="paginationParams.maxSize"
                               [responsive]="paginationParams.responsive"
                               [previousLabel]="paginationLabels.previousLabel"
                               [nextLabel]="paginationLabels.nextLabel"
                               [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                               [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                               [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
          ></pagination-controls>
        </div>
        <div *ngIf="inspectionDeliveryRequests.length === 0" style="text-align: center; height: 150px; padding-top: 60px;">
          Nessuna richiesta di consegna associata.
        </div>
      </div>
      <div *ngIf="user.fk_id_role <= 1" class="panel-footer" style="text-align: center;">
        <a class="btn btn-success" [routerLink]="['/inspection/rdc/create/' + inspectionOrder.id_inspection_order]"><i class="icon-plus"></i> Aggiungi</a>
      </div>
    </div>
  </div>
</div>
